import { useAuthStore } from '@/store/useAuthStore'

export function usePermissions() {
  const permissions = useAuthStore((s) => s.permissions)
  const isSuperuser = useAuthStore((s) => s.user?.is_superuser)

  const has = (permission: string): boolean => {
    if (isSuperuser) return true
    return permissions.includes(permission)
  }

  const hasAny = (...perms: string[]): boolean => {
    if (isSuperuser) return true
    return perms.some((p) => permissions.includes(p))
  }

  const hasAll = (...perms: string[]): boolean => {
    if (isSuperuser) return true
    return perms.every((p) => permissions.includes(p))
  }

  return { permissions, has, hasAny, hasAll }
}
